import React, { Fragment, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Color, LuxIcon, LuxToast, LuxUserAvatar } from '@lux/wardrobe-lib'
import {
    Analytics,
    layoutActions,
    ModalsType,
    UserHelper,
    filtersActions,
} from '@Techedge/digitalportal-shared'
import './smart-navbar.scss'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'

const SmartNavbar = (props: any) => {
    const {
        userState,
        getFilters,
        activeFilter,
        filtersList,
        accessToken,
        closeModal,
    } = props

    const [user, setUser] = useState(UserHelper._shared().user())
    const [userAvatar, setUserAvatar] = useState(userState.profilePicURL)

    const toastRef: any = useRef()
    const intl = useIntl()

    const navigate = useNavigate()

    useEffect(() => {
        if (accessToken) {
            getFilters()
        }
    }, [accessToken])

    useEffect(() => {
        if (activeFilter) {
            toastRef.current.show([
                {
                    id: 'global-filters',
                    detail: intl.formatMessage({
                        id: 'navbar.filters.disclaimer.message',
                        defaultMessage: 'Filters applied on page content',
                    }),
                    life: 3000,
                },
            ])
        } else {
            toastRef?.current?.clear()
        }
    }, [activeFilter, filtersList])

    const isLogoVisible = (): boolean => {
        const pathname = window.location.pathname // Il percorso (ad esempio, /path/to/page)
        switch (pathname) {
            case '/home':
            case '/calendar':
            case '/activity':
            case '/notifications':
            case '/resources':
            case '/menu/profile':
            case '/menu':
            case '/gallery':
            case '/menu/forum':
            case '/menu/quick-links':
            case '/menu/store-list':
            case '/reporting':
            case '/aftersales':
            case '/menu/profile-mgmt':
            case '/menu/profile-mgmt/profiles':
            case '/':
                return true
            default:
                return false
        }
    }

    useEffect(() => {
        setUser(userState)
        if (userState.profilePicURL) setUserAvatar(userState.profilePicURL)
    }, [userState])

    if (!props.showNavbar) return <Fragment></Fragment>

    return (
        <div id="smart-navbar" className="navbar-extended">
            <div className="navbar-content">
                <div
                    className="navbar-user"
                    onClick={() => {
                        closeModal()
                        navigate('/menu/profile')
                    }}>
                    <div className="user-avatar">
                        <LuxUserAvatar
                            userName={user.given_name || ''}
                            userLastname={user.family_name || ''}
                            avatarImage={userAvatar}
                            size={32}
                        />
                        <div className="user-status"></div>
                    </div>
                    <label className="user-name">{`${
                        user.given_name && user.given_name !== 'undefined'
                            ? user.given_name
                            : ''
                    } ${
                        user.family_name && user.family_name !== 'undefined'
                            ? user.family_name
                            : ''
                    }`}</label>
                </div>
                {isLogoVisible() && (
                    <div className="navbar-logo">
                        <img
                            src={`${process.env.SMARTLY_URL}/styleguide/assets/images/logo_smartly.svg`}
                            alt={`smartly logo`}
                        />
                    </div>
                )}
                <div className="navbar-icons">
                    <div
                        onClick={() => {
                            Analytics._sendAnalyticsClickEvent(
                                'search',
                                'Click on Search Icon'
                            )
                            props.openSearch()
                            closeModal()
                        }}>
                        <LuxIcon icon="search" color={Color.WHITE} size={20} />
                    </div>
                    <div
                        onClick={() => {
                            Analytics._sendAnalyticsClickEvent(
                                'filters',
                                'Filters - Apply filters'
                            )
                            props.openFilters()
                        }}>
                        <LuxIcon icon="filter" color={Color.WHITE} size={20} />
                        {props.activeFilter && (
                            <div className="navbar-item--badge"></div>
                        )}
                    </div>
                </div>
            </div>
            <LuxToast
                className="filters-disclaimer-toast"
                elref={toastRef}
                toastItems={[]}
                position="top-right"
            />
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    accessToken: state.userReducer.accessToken,
    activeFilter: state.filtersReducer.activeFilter,
    filtersList: state.filtersReducer.filtersList,
    userState: state.userReducer.user,
    showNavbar: state.layoutReducer.showNavbar,
    showFilters: state.layoutReducer.showFilters,
    portals: state.userReducer.permissions?.portals,
})

const mapDispatchToProps = (dispatch: any) => ({
    closeModal: () => {
        dispatch(layoutActions.setModals({ type: null, props: {} }))
    },
    openFilters: () => {
        dispatch(layoutActions.setModals({ type: ModalsType.FILTERS }))
    },
    getFilters: () => {
        dispatch(filtersActions.loadFilterList())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartNavbar)
